import createLucideIcon from '../createLucideIcon';

const Codepen = createLucideIcon('CodepenIcon', [
  [
    'polygon',
    { points: '12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2', key: 'srzb37' },
  ],
  ['line', { x1: '12', y1: '22', x2: '12', y2: '15.5', key: 'zsefro' }],
  ['polyline', { points: '22 8.5 12 15.5 2 8.5', key: 'ajlxae' }],
  ['polyline', { points: '2 15.5 12 8.5 22 15.5', key: 'susrui' }],
  ['line', { x1: '12', y1: '2', x2: '12', y2: '8.5', key: 'zll5ve' }],
]);

export default Codepen;
